import { render } from "./BeritaOPD.vue?vue&type=template&id=6642f432"
import script from "./BeritaOPD.vue?vue&type=script&lang=js"
export * from "./BeritaOPD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__